<template>
    <div class="wrapper section_wrapper section_information_wrapper">
        <div class="container">
            <div class="section_title" v-if="current_page['display_name']"><h1>{{ current_page['display_name'] }}</h1></div>
            <div class="section_content" v-html="current_page['content']"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Content',
        data() {
            let current_object = this;
            let root = current_object.$root;
            let data_set = {
                current_page:{
                    display_name:'Blank Resource Page',
                    content:'<p>Hello World</p>'
                },
                left_menu:[]
            };
            if (root.current_id.page && root.item_map) {
                if (root.item_map.page && root.item_map.page[root.current_id.page]) {
                    data_set.current_page = root.item_map.page[root.current_id.page];
console.log('allen debug data_set.current_page',data_set.current_page);
                }
            }
// console.log('allen debug Resources current_page',data_set.current_page,data_set.left_menu);
            // if (root.item_list && data_set.current_page['left_menu_name'] && root.item_list[data_set.current_page['left_menu_name']]) {
            //     data_set.left_menu = root.item_list[data_set.current_page['left_menu_name']][0]._ref_list_children;
            //     data_set.left_menu.forEach(function (menu_item) {
            //         console.log(menu_item.page_id,root.current_id.page,menu_item.page_id === root.current_id.page);
            //         if (menu_item.page_id === root.current_id.page) {
            //             data_set.current_menu_item = menu_item;
            //             data_set.parent_menu_item = menu_item;
            //         } else {
            //             if (menu_item._ref_list_children) {
            //                 menu_item._ref_list_children.forEach(function (sub_menu_item) {
            //                     if (sub_menu_item.page_id === root.current_id.page) {
            //                         data_set.current_menu_item = sub_menu_item;
            //                         data_set.parent_menu_item = menu_item;
            //                     }
            //                 });
            //             }
            //         }
            //     });
            //
            // }
// console.log('allen debug current_menu_item',data_set.current_menu_item,data_set.parent_menu_item,root.current_id.page);
            return data_set;
        },
        mounted() {
            $('.expandable_image_container .expand_trigger').on('click', function () {
                let expand_parent = $(this).closest('.expandable_image_container');
                let expand_wrapper = expand_parent.children('.expand_wrapper');
                if (expand_parent.hasClass('expand_parent_expanded')) {
                    expand_wrapper.animate({
                        height: 0
                    },500,function () {
                        expand_parent.removeClass('expand_parent_expanded')
                    });
                } else {
                    expand_wrapper.animate({
                        height: expand_wrapper.children('.expand_container').outerHeight()
                    },500,function () {
                        expand_parent.addClass('expand_parent_expanded')
                    });
                }
            });
        },
        computed: {

        },
        methods: {

        }
    }
</script>